var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import KPIBox from "../KPIBox";
import Funnel from "../charts/Funnel";
import BarChart from "../charts/BarChart";
import DonutChart from "../charts/DonutChart";
import { IndicatorLoader } from "../DashboardUtils";
import CampaignRenderer from "../CampaignRenderer";
import { FaGoogle } from "react-icons/fa";
var GoogleRenderer = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var googleGeneral = _a.googleGeneral, googleBreakdown = _a.googleBreakdown, campaigns = _a.campaigns, campaignsInsights = _a.campaignsInsights, loadingCampaigns = _a.loadingCampaigns, name = _a.name, id = _a.id;
    if (!googleGeneral) {
        return (React.createElement("div", { className: "max-w-7xl mx-auto px-4 py-6" },
            React.createElement("h2", { className: "text-3xl font-bold text-center mb-2" }, "Google ADS"),
            React.createElement("div", { className: "text-center text-gray-400 py-12" }, "Carregando dados do Google Ads...")));
    }
    // Usa dados reais se vierem do backend, senão usa fake
    var conversoesPorCidade = useMemo(function () {
        if (googleBreakdown === null || googleBreakdown === void 0 ? void 0 : googleBreakdown.conversoes_por_cidade) {
            return googleBreakdown.conversoes_por_cidade;
        }
        return { "Cidade": "?" };
    }, [googleBreakdown]);
    var conversoesPorIdade = useMemo(function () {
        if (googleBreakdown === null || googleBreakdown === void 0 ? void 0 : googleBreakdown.conversoes_por_idade) {
            return googleBreakdown.conversoes_por_idade;
        }
        return {
            "18-24": 80,
            "25-34": 200,
            "35-44": 250,
            "45-54": 180,
            "55-64": 100,
            "65+": 50,
        };
    }, [googleBreakdown]);
    var conversoesPorGenero = useMemo(function () {
        if (googleBreakdown === null || googleBreakdown === void 0 ? void 0 : googleBreakdown.conversoes_por_genero) {
            return googleBreakdown.conversoes_por_genero;
        }
        return {
            "Masculino": 400,
            "Feminino": 500,
            "Outro": 50,
        };
    }, [googleBreakdown]);
    var funnelData = useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        return [
            {
                label: "Impressões",
                value: (_a = googleGeneral.current) === null || _a === void 0 ? void 0 : _a.impressions,
                previous: (_b = googleGeneral.previous) === null || _b === void 0 ? void 0 : _b.impressions,
                color: "#b6ff00"
            },
            {
                label: "Cliques",
                value: (_c = googleGeneral.current) === null || _c === void 0 ? void 0 : _c.clicks,
                previous: (_d = googleGeneral.previous) === null || _d === void 0 ? void 0 : _d.clicks,
                color: "#ffe600"
            },
            {
                label: "Conversões",
                value: (_e = googleGeneral.current) === null || _e === void 0 ? void 0 : _e.conversions,
                previous: (_f = googleGeneral.previous) === null || _f === void 0 ? void 0 : _f.conversions,
                color: "#00e1ff"
            },
            {
                label: "Vendas",
                value: "?",
                previous: "?",
                color: "#ff2d2d"
            }
        ];
    }, [googleGeneral]);
    return (React.createElement("div", { className: "max-w-7xl mx-auto px-4 py-6" },
        React.createElement("div", { className: "bg-gradient-to-r from-[#16a34a] to-[#16a34a] text-white-fallback p-1 flex items-center justify-center gap-2" },
            React.createElement(FaGoogle, { className: "w-5 h-5" }),
            React.createElement("span", { className: "font-semibold text-lg" }, "Google ADS")),
        React.createElement("div", { className: "backdrop-blur-md bg-gradient-to-br from-cyan-900/80 via-gray-900/90 to-cyan-950/80 border-2 \n            border-[#16a34a] shadow-2xl rounded-b-2xl p-10 mb-16" },
            React.createElement("div", { className: "flex items-center gap-3 mb-4" },
                React.createElement(FaGoogle, { className: "w-10 h-10 text-cyan-300" }),
                React.createElement("span", { className: "bg-cyan-400/20 text-cyan-200 px-3 py-1 rounded-full text-xs font-bold tracking-widest" }, "GERAL DA CONTA")),
            React.createElement("p", { className: "text-gray-400 mb-6 text-sm" }, "Vis\u00E3o consolidada de todas as campanhas ativas nesta conta."),
            React.createElement("div", { className: "grid grid-cols-4 gap-6 mb-8" },
                React.createElement("div", { className: "flex flex-col h-full justify-between" },
                    React.createElement("div", { className: "p-3 flex flex-col items-center justify-center h-[340px]" },
                        React.createElement(Funnel, { data: funnelData })),
                    React.createElement("div", { className: "flex flex-col gap-4 h-full justify-between" },
                        React.createElement(KPIBox, { label: "CPC M\u00E9dio", value: (_b = googleGeneral.current) === null || _b === void 0 ? void 0 : _b.average_cpc, previous: (_c = googleGeneral.previous) === null || _c === void 0 ? void 0 : _c.average_cpc, prefix: "R$ ", decimals: 2 }),
                        React.createElement(KPIBox, { label: "CTR (%)", value: (_d = googleGeneral.current) === null || _d === void 0 ? void 0 : _d.ctr, previous: (_e = googleGeneral.previous) === null || _e === void 0 ? void 0 : _e.ctr, decimals: 2 }))),
                React.createElement("div", { className: "flex flex-col gap-4 h-full justify-between" },
                    React.createElement(KPIBox, { label: "Investimento", value: (_f = googleGeneral.current) === null || _f === void 0 ? void 0 : _f.cost, previous: (_g = googleGeneral.previous) === null || _g === void 0 ? void 0 : _g.cost, prefix: "R$ ", decimals: 2 }),
                    React.createElement(KPIBox, { label: "Impress\u00F5es", value: (_h = googleGeneral.current) === null || _h === void 0 ? void 0 : _h.impressions, previous: (_j = googleGeneral.previous) === null || _j === void 0 ? void 0 : _j.impressions }),
                    React.createElement(KPIBox, { label: "Cliques", value: (_k = googleGeneral.current) === null || _k === void 0 ? void 0 : _k.clicks, previous: (_l = googleGeneral.previous) === null || _l === void 0 ? void 0 : _l.clicks }),
                    React.createElement(KPIBox, { label: "Convers\u00F5es", value: (_m = googleGeneral.current) === null || _m === void 0 ? void 0 : _m.conversions, previous: (_o = googleGeneral.previous) === null || _o === void 0 ? void 0 : _o.conversions }),
                    React.createElement(KPIBox, { label: "Custo/Convers\u00E3o", value: (_p = googleGeneral.current) === null || _p === void 0 ? void 0 : _p.cost_per_conversion, previous: (_q = googleGeneral.previous) === null || _q === void 0 ? void 0 : _q.cost_per_conversion, prefix: "R$ ", decimals: 2 })),
                React.createElement("div", { className: "col-span-1 grid grid-cols-1 gap-4" },
                    React.createElement("div", { className: "bg-gray-900/80 rounded-lg p-3 flex flex-col h-[560px]" },
                        React.createElement("div", { className: "text-xs text-gray-400 mb-2" }, "Convers\u00F5es por Cidade"),
                        React.createElement(BarChart, { resultsByDay: Object.entries(conversoesPorCidade).reduce(function (acc, _a) {
                                var cidade = _a[0], valor = _a[1];
                                acc[cidade] = { conversoes: Number(valor) };
                                return acc;
                            }, {}), fields: [{ key: "conversoes", label: "Conversões", color: "#3b82f6", type: "bar" }], height: 510, horizontal: true }))),
                React.createElement("div", { className: "col-span-1 grid grid-cols-1 gap-4" },
                    React.createElement("div", { className: "bg-gray-900/80 rounded-lg p-3 flex flex-col h-[265px]" },
                        React.createElement("div", { className: "text-xs text-gray-400 mb-2" }, "Convers\u00F5es por G\u00EAnero"),
                        React.createElement(DonutChart, { results: Object.entries(conversoesPorGenero).reduce(function (acc, _a) {
                                var genero = _a[0], valor = _a[1];
                                acc[genero] = { conversoes: valor };
                                return acc;
                            }, {}), fields: [{ key: "conversoes", label: "Conversões" }], height: 220, backgroundColor: ["#3b82f6", "#a78bfa", "#94a3b8"] })),
                    React.createElement("div", { className: "bg-gray-900/80 rounded-lg p-3 flex flex-col h-[265px]" },
                        React.createElement("div", { className: "text-xs text-gray-400 mb-2" }, "Convers\u00F5es por Idade"),
                        React.createElement(BarChart, { resultsByDay: Object.entries(conversoesPorIdade).reduce(function (acc, _a) {
                                var idade = _a[0], valor = _a[1];
                                acc[idade] = { conversoes: valor };
                                return acc;
                            }, {}), fields: [{ key: "conversoes", label: "Conversões", color: "#00e1ff", type: "bar" }], height: 220 }))))),
        loadingCampaigns ? (React.createElement(IndicatorLoader, null)) : campaigns.length > 0 ? (React.createElement("div", { className: "max-w-7xl mx-auto px-4" }, campaigns
            .filter(function (camp) { return camp.platform === "google"; })
            .map(function (camp) {
            var _a, _b, _c, _d;
            return (React.createElement("div", { key: camp.id, className: "bg-gray-900/80 rounded-lg mb-6 ", style: { border: "solid 1px #111827cc" } },
                React.createElement(CampaignRenderer, { campaign: __assign(__assign({}, camp), { name: ((_a = campaignsInsights[camp.id]) === null || _a === void 0 ? void 0 : _a.campaign_name) || camp.name }), insights: {
                        current: (_b = campaignsInsights[camp.id]) === null || _b === void 0 ? void 0 : _b.current,
                        previous: (_c = campaignsInsights[camp.id]) === null || _c === void 0 ? void 0 : _c.previous,
                        results_by_day: (_d = campaignsInsights[camp.id]) === null || _d === void 0 ? void 0 : _d.results_by_day
                    } })));
        }))) : (React.createElement("div", { className: "max-w-2xl mx-auto px-4 py-12 text-center text-lg text-gray-300" },
            "Nenhuma campanha ativa para visualiza\u00E7\u00E3o.",
            React.createElement("br", null),
            React.createElement("a", { href: "/dashboards-settings/".concat(name, "/").concat(id), className: "text-cyan-400 underline hover:text-cyan-300 transition" }, "Ative as campanhas que deseja visualizar neste dashboard")))));
};
export default GoogleRenderer;
